import { Navigate } from "react-router-dom";

import { useAuth } from "@/hooks/useAuth";
import { useMyProfile } from "@/hooks/useMe";
import { DashboardPage } from "@/pages/DashboardPage";

/**
 * Aterrizaje de la ruta raíz "/".
 *
 * La ruta index no estaba protegida por segmento: cualquier usuario
 * autenticado caía en DashboardPage (Incidentes) aunque no tuviera el
 * segmento `dashboard`. Este componente decide el aterrizaje según los
 * segmentos del usuario (leídos de /me/profile):
 *
 *   - super_user o segmento `dashboard` → Incidentes (comportamiento previo)
 *   - segmento `dashboards`             → paneles Grafana (/dashboards)
 *   - sin vista principal               → su perfil (/settings/profile)
 *
 * Nota: el menú lateral (Layout) ya ocultaba "Incidentes" sin el segmento,
 * pero la ruta `/` quedaba expuesta; esto cierra ese hueco en el aterrizaje.
 */
export function HomeLanding() {
  const { user } = useAuth();
  const profile = useMyProfile();

  // DEV-ONLY: preview local sin backend (mismo criterio que RequireAuth).
  if (import.meta.env.DEV) return <DashboardPage />;

  if (profile.isPending) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center text-sm text-muted-foreground">
        Cargando…
      </div>
    );
  }

  const segments = new Set(profile.data?.segments ?? []);
  const isSuper =
    (profile.data?.global_roles ?? []).includes("super_user") || user?.role === "admin";

  if (isSuper || segments.has("dashboard")) return <DashboardPage />;
  if (segments.has("dashboards")) return <Navigate to="/dashboards" replace />;
  return <Navigate to="/settings/profile" replace />;
}
